import styled, { css } from 'styled-components'

export const Line = styled.div<LineProps>`
  ${({ orientation, margin, size }) => css`
    ${orientation === 'horizontal' &&
    css`
      border-top: 1px solid #f3f3f3;
      width: ${size ? size : '100%'};
      margin-top: ${margin ? margin : '0'};
      margin-bottom: ${margin ? margin : '0'};
    `}

    ${orientation === 'vertical' &&
    css`
      border-left: 1px solid #f3f3f3;
      height: {!!size ? size : '100%'};
      margin-left: ${margin ? margin : '0'};
      margin-right: ${margin ? margin : '0'};
    `}
  `}
`
